/**
 * Utilitaires de saisie/affichage des MONTANTS du profil prestataire
 * (Capital, chiffre d'affaires) et des pourcentages associes.
 *
 * CA et capital sont des ENTIERS (euros) : la saisie tolere le format FR
 * (virgule, separateurs de milliers) et est arrondie a l'euro. Les
 * pourcentages (part CA / part RH) restent decimaux.
 */

// Espaces a retirer d'une saisie : espace normal, insecable, fine insecable, fine.
const SPACE_RE = /[\s   ]/g;

/**
 * Convertit une valeur d'API (nombre OU chaine decimale "4704489874.54")
 * en nombre JS, ou null si vide/invalide.
 */
export function toNumber(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : parseFloat(String(value));
  return Number.isFinite(n) ? n : null;
}

/**
 * Parse une saisie utilisateur au format FR (virgule decimale, espaces de
 * milliers) en nombre, ou null si vide/invalide.
 */
export function parseMontantFr(value: string | null | undefined): number | null {
  if (value === null || value === undefined) return null;
  const cleaned = String(value).replace(SPACE_RE, '').replace(',', '.');
  if (cleaned === '' || cleaned === '.' || cleaned === '-') return null;
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : null;
}

/**
 * Formate un montant/pourcentage pour un CHAMP DE SAISIE (au blur) :
 * separateurs de milliers FR, jusqu'a 2 decimales, sans forcer les ",00".
 * Convient aussi aux pourcentages (valeurs <= 100 -> pas de separateur).
 */
export function formatMontantInput(value: number | string | null | undefined): string {
  const n = toNumber(value);
  if (n === null) return '';
  return n.toLocaleString('fr-FR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
